// Set colours accent classes
export const ThemeSetColorsAccent = accent_colour => {
  if (accent_colour && accent_colour !== "none") {
    return " accent-" + accent_colour;
  }
};
